import React from 'react';
import { Controller, useFormContext } from 'react-hook-form';

import { ErrorMessage, FormLabel } from '../../styled';
import RichTextEditor from '../RichTextEditor';

const Content: React.FC = () => {
    const { control } = useFormContext();

    return (
        <Controller
            name='content'
            control={control}
            render={({ field, fieldState }) => (
                <div>
                    <FormLabel>Content</FormLabel>
                    <RichTextEditor field={field} />
                    {fieldState.error && <ErrorMessage>{fieldState.error.message}</ErrorMessage>}
                </div>
            )}
        />
    );
};

export default Content;
